import { render, staticRenderFns } from "./Clist.vue?vue&type=template&id=2548843c&scoped=true"
import script from "./Clist.vue?vue&type=script&lang=js"
export * from "./Clist.vue?vue&type=script&lang=js"
import style0 from "./Clist.vue?vue&type=style&index=0&id=2548843c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548843c",
  null
  
)

export default component.exports